import { UserAppPreferencesService } from 'api/services/UserAppPreferencesService'
import { Menu } from 'blaze-ui/icons'
import { Button } from './Button'
import { TopBarButton } from './TopBarButton'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

export const UnlockButton = () => {
  const { isMobile } = useResponsiveDesign()
  const handlePress = () => {
    UserAppPreferencesService.lockSidebar()
  }

  if (isMobile) {
    return <TopBarButton icon={Menu} onPress={handlePress} label="Sidebar Menu" />
  }

  return <Button icon={Menu} onPress={handlePress} aria-label="Sidebar Menu" />
}
